export function StyleNormalizer (pEditor, pStyle)
{
  this.checkMsHTML = (content) =>
  {
    if (!content)
    {
      content = pEditor.content.getHtmlData();
    }

    return (content.match(/class\s*=(?:\s*(['"])[\S\s]*?[M]so(?=[\S\s]*?\1)|[M]so)/i) ||
            content.match(/mso-[^\s:]*\s*\:[^;'"]*;?/i) ||
            content.match(/<\\?\?xml[^>]*>/i) ||
            content.match(/<\/?o:[^>]*>/i) ||
            content.match(/tab-stops: list [0-9]+.0pt">/i) ||
            content.match(/<br style="page-break-before: always;[^>]*>/i)) ? true : false;
  };


  this.convertDifferentTags = (content) =>
  {
    if (!content)
    {
      return '';
    }

    content = content.replace(/<(\/)?B([\s>])/ig, '<$1STRONG$2');
    content = content.replace(/<(\/)?I([\s>])/ig, '<$1EM$2');

    return content;
  };


  this.clearMsHTML = (content) =>
  {
    var tempDiv;

    if (content && content.length > 0)
    {
      var reTestEmptyTag = /<(span|u|i|b|strong|em|font)[^>]*?>\s*?<\/\1>/ig;
      var charBull = String.fromCharCode(8226);
      var charMiddot = String.fromCharCode(183);

      content = content.replace(/&quot;/ig, '###QUOT###');

      content = content.replace(/<\!--\[if\s+!supportLists\]-->((?:.|\n|\r)*?)<\!--\[endif\]-->/ig, '$1');
      content = content.replace(/<\/[ovwmxp]:[^>]*?>|<[ovwmxp]:[^\/]*?\/.*?>|<\/?xml>|<(meta|link).*?>|<style>[\s\S]*?<\/style>|<!--\[if[\s\S]*?\[endif\]-->/ig, "");

      content = content.replace(/tab-stops: list [0-9]+.0pt">/ig, '">' + '###LIST###');
      content = content.replace(/<SPAN style="mso-list: Ignore">/ig, '<span>' + charBull);
      content = content.replace(/((?:<p.*MsoList[\s\S]*?<\/p>\s*)+)/ig, "<ul>$1</ul>");
      content = content.replace(/<p\s[^>]*?class=(?:"[^">]*?MsoList[^">]*"|'[^'>]*?MsoList[^'>]*')[^>]*?>(?:<span[^>]*?>)?([\s\S]*?)(?:<\/span>)?<\/p>/ig, "<li>$1</li>");
      content = content.replace(/<o:p><\/o:p>/ig, '');
      content = content.replace(/\sclass=(?:['"]?[M]so[\w\d\-'"]*)/ig, "");
      content = content.replace(/\sclass=(?:['"]?[S]tyle[A-Z][a-z][\w\d\-'"]*)/ig, '');
      content = content.replace(/<br style="page-break-before: always;[^>]*>/ig, '###PageBreak###');
      content = content.replace(/<(!--)([^>]*)(--)>/g, '');

      content = content.replace(/(<[A-Za-z0-9]+[^>]*\s)lang=['"\w\d-]*/ig, '$1');
      content = content.replace(/mso-[^\s:]*\s*\:[^;'"]*;?/ig, '');

      content = content.replace(/<\\?\?xml[^>]*>/ig, '');
      content = content.replace(/<\/?o:[^>]*>/ig, '');
      content = content.replace(/###PageBreak###\s*<p>&nbsp;<\/p>/ig, '');
      content = content.replace(/###PageBreak###/ig, '');

      tempDiv = pEditor.iFrameDoc.createElement('DIV');
      tempDiv.innerHTML = content;

      while (convertMsList(tempDiv, '###LIST###'));
      while (convertMsList(tempDiv, charBull));

      content = tempDiv.innerHTML;
      content = content.replace(/###LIST###/ig, '');

      content = content.replace(/\s(?:class|style)=(?:"\s*"|'\s*'|\s)/g, "");

      content = content.replace(/###QUOT###/ig, '&quot;');

      while (reTestEmptyTag.test(content))
      {
        content = content.replace(reTestEmptyTag, ' ');
      }
    }

    return content;
  };


  function convertMsList(eDiv, formatString, listClassName)
  {
    var i;
    var eP, nextP, nextNextP, eUL, eLI;
    var prevUL = null;
    var charBull = String.fromCharCode(8226);
    var charMiddot = String.fromCharCode(183);
    var nodes = eDiv.getElementsByTagName('P');

    for (i = 0; i < nodes.length; i++)
    {
      eP = nodes[i];

      if (eP.innerHTML.indexOf(formatString) == 0)
      {
        eUL = document.createElement('UL');

        if (listClassName)
        {
          eUL.className = listClassName;
        }

        eLI = document.createElement('LI');
        eLI.innerHTML = eP.innerHTML.replace(new RegExp('' + charMiddot + '|' + charBull + '|###LIST###|&nbsp;', 'ig'), '');
        eUL.appendChild(eLI);

        nextP = eP.nextSibling;

        while (nextP)
        {
          if (nextP.nodeType == 3 && new RegExp('^\\s$', 'm').test(nextP.nodeValue))
          {
            nextP = nextP.nextSibling;
            continue;
          }

          if (formatString == charMiddot)
          {
            if (nextP.nodeType == 1 && new RegExp('^o(\\s+|&nbsp;)').test(nextP.innerHTML))
            {
              if (!prevUL)
              {
                prevUL = eUL;
                eUL = document.createElement('UL');
                prevUL.appendChild(eUL);
              }

              nextP.innerHTML = nextP.innerHTML.replace(/^o/, '');
            }
            else
            {
              if (prevUL)
              {
                eUL = prevUL;
                prevUL = null;
              }

              if (nextP.nodeType != 1 || nextP.innerHTML.indexOf(formatString) != 0)
              {
                break;
              }
            }
          }
          else
          {
            if (nextP.nodeType != 1 || nextP.innerHTML.indexOf(formatString) != 0)
            {
              break;
            }
          }

          nextNextP = nextP.nextSibling;
          eLI = document.createElement('LI');
          eLI.innerHTML = nextP.innerHTML.replace(new RegExp('' + charMiddot + '|' + charBull + '|###LIST###|&nbsp;', 'ig'), '');
          nextP.parentNode.removeChild(nextP);
          eUL.appendChild(eLI);
          nextP = nextNextP;
        }

        eP.parentNode.replaceChild(eUL, eP);

        return true;
      }
    }

    return false;
  }


  this.fixWebKitHTMLInline = (htmlSource, htmlSourceDoc) =>
  {
    if (!BEditor.browser.isWebKit) return;

    htmlSource = htmlSource || pEditor.iFrameDoc.body;
    htmlSourceDoc = htmlSourceDoc || pEditor.iFrameDoc;

    var i,
        wkClass,
        webkitSpans = htmlSource.getElementsByTagName('SPAN'),
        newTag = null;

    for (i = 0; i < webkitSpans.length; i++)
    {
      if (webkitSpans[i].className && webkitSpans[i].className.toLowerCase().indexOf('apple-style-span') != -1)
      {
        if (webkitSpans[i].style.textDecoration)
        {
          if (webkitSpans[i].style.textDecoration.toLowerCase().indexOf('underline') != -1)
          {
            newTag = htmlSourceDoc.createElement('U');
          }
          else if (webkitSpans[i].style.textDecoration.toLowerCase().indexOf('line-throug') != -1)
          {
            newTag = htmlSourceDoc.createElement('STRIKE');
          }

          if (newTag)
          {
            newTag.innerHTML = webkitSpans[i].innerHTML;
            webkitSpans[i].innerHTML = '';

            if (webkitSpans[i].style.backgroundColor)
            {
              webkitSpans[i].appendChild(newTag);
              webkitSpans[i].className = webkitSpans[i].className.replace(/apple-style-span/, '');
            }
            else
            {
              webkitSpans[i].parentNode.replaceChild(newTag, webkitSpans[i]);
              i--;
            }
          }
        }
        else if (!webkitSpans[i].getAttribute('style') && webkitSpans[i].parentNode.innerHTML === webkitSpans[i].outerHTML)
        {
          webkitSpans[i].parentNode.innerHTML = webkitSpans[i].innerHTML;
        }
      }
    }

    var webkitBlockquote = htmlSource.getElementsByTagName('BLOCKQUOTE');

    for (i = 0; i < webkitBlockquote.length; i++)
    {
      wkClass = webkitBlockquote[i].className;
      wkClass = wkClass.replace(/\s*webkit-indent-blockquote\s*/ig, ' ').replace(/(?:^\s+|\s+$)/g, '');

      if (wkClass.replace(/\s+/g, '') != '')
      {
        webkitBlockquote[i].className = wkClass;
      }
      else
      {
        webkitBlockquote[i].removeAttribute('class');
      }
    }
  };


  this.fixWebKitSelfStyles = (isBeforeExec, command) =>
  {
    pEditor.undoRedo.isStopSaveUndo = true;
    pEditor.contentChecker.setExcludeWordCheck();

    if (isBeforeExec)
    {
      markExistingElements('*', [{'style': {'fontSize': '*'}}], [{'style': 'fontSize'}]);
    }
    else
    {
      if (command === 'indent')
      {
        fixWebKitBlockquote();
      }

      unmarkExistingElements('*', [{'style': 'fontSize'}]);

      pEditor.undoRedo.saveUndoDo(true);
      pEditor.undoRedo.isStopSaveUndo = false;
    }
  };


  function fixWebKitBlockquote ()
  {
    var reBlockquote = /blockquote/i;
    var currentRange = pEditor.range.getCurrent();
    var element = pEditor.helpers.element.getParentElementByTagsNames(currentRange, reBlockquote);

    if (element)
    {
      element.removeAttribute('style');

      while (element = pEditor.helpers.element.getParentElementFromElementByTagsNames(element.parentNode, reBlockquote))
      {
        element.removeAttribute('style');
      }
    }
  }


  this.fixWebKitHR = () =>
  {
    if (!BEditor.browser.isWebKit) return;

    var i;
    var elements = pEditor.iFrameDoc.body.getElementsByTagName('HR');

    for (i = 0; i < elements.length; i++)
    {
      if (elements[i].getAttribute('width') && elements[i].getAttribute('width') == '100%')
      {
        elements[i].removeAttribute('width');
      }
    }
  };


  this.restoreWebKitHTMLInline = (htmlContent) =>
  {
    if (!BEditor.browser.isWebKit) return (htmlContent != null) ? htmlContent : null;

    if (htmlContent != null)
    {
      htmlContent = htmlContent.replace(/<U([\s>])/ig, '<span class="Apple-style-span" style="text-decoration: underline;"$1');
      htmlContent = htmlContent.replace(/<\/U([\s>])/ig, '</span$1');
      htmlContent = htmlContent.replace(/<STRIKE([\s>])/ig, '<span class="Apple-style-span" style="text-decoration: line-through;"$1');
      htmlContent = htmlContent.replace(/<\/STRIKE([\s>])/ig, '</span$1');

      htmlContent = htmlContent.replace(/<BLOCKQUOTE([^>]*)>/ig, function (bigStr, tagBody)
      {
        if ((/\sclass\s*=/i).test(tagBody))
        {
          return '<blockquote' + tagBody.replace(/\sclass\s*=['"]([^'"]*)(?:webkit-indent-blockquote)?([^'"]*)['"]/i, ' class="webkit-indent-blockquote $1$2"') + '>';
        }
        else
        {
          return '<blockquote class="webkit-indent-blockquote"' + tagBody + '>';
        }
      });

      return htmlContent;
    }
    else
    {
      var revertTags =
      {
        'U' :
        {
          'textDecoration' : 'underline'
        },

        'STRIKE' :
        {
          'textDecoration' : 'line-through'
        }
      };

      var i;
      var keyTag, keyStyle;
      var tags;
      var newTag = null;

      for (keyTag in revertTags)
      {
        if (!revertTags.hasOwnProperty(keyTag)) continue;
        tags = pEditor.iFrameDoc.body.getElementsByTagName(keyTag);

        while(tags && tags.length)
        {
          newTag = pEditor.iFrameDoc.createElement('SPAN');
          newTag.className = 'Apple-style-span';

          for (keyStyle in revertTags[keyTag])
          {
            if (!revertTags[keyTag].hasOwnProperty(keyStyle)) continue;
            newTag.style[keyStyle] = revertTags[keyTag][keyStyle];
          }

          newTag.innerHTML = tags[0].innerHTML;
          tags[0].parentNode.replaceChild(newTag, tags[0]);
        }
      }

      tags = pEditor.iFrameDoc.body.getElementsByTagName('BLOCKQUOTE');

      for (i = 0; i < tags.length; i++)
      {
        if (tags[i].className.replace(/\s+/g, '') != '')
        {
          tags[i].className = 'webkit-indent-blockquote' + ((tags[i].className.replace(/\s+/g, '') != '') ? ' ' + tags[i].className : '');
        }
        else
        {
          tags[i].className = 'webkit-indent-blockquote';
        }
      }
    }
  };


  this.removeWaWebKitSavedSpanIndex = (htmlContent) =>
  {
    htmlContent = htmlContent.replace(/((?:font-family|font)\s*:\s*)(.*?)(?:WaWebKitSavedSpanIndex_\d+,?\s*)+([^;"]*)([;"])/ig, function (str, rule, firstFont, secondFont, endStr)
    {
      var res = '';

      if (firstFont || secondFont)
      {
        res = rule;
        res += (firstFont != null ? firstFont : '') + (secondFont != null ? secondFont : '');
        res = res.replace(/,\s*$/, '');
        res += endStr;
      }

      return res;
    });

    return htmlContent;
  };


  function markExistingElements (elementName, checkAttributes, saveAttributes)
  {
    var i,
        elements = pEditor.iFrameDoc.body.getElementsByTagName(elementName);

    if (elements && elements.length)
    {
      for (i = elements.length; i--;)
      {
        if (checkAttributes)
        {
          if (checkAttributes[0]['style'] && (checkAttributes[0]['style'].value == '*' || elements[i].style[checkAttributes[0]['style'].name] == checkAttributes[0]['style'].value))
          {
            elements[i].setAttribute('data-waelementmarker', '1');

            if (saveAttributes)
            {
              if (saveAttributes[0]['style'] && elements[i].style[saveAttributes[0]['style']] != null && elements[i].style[saveAttributes[0]['style']] != '')
              {
                elements[i].setAttribute('data-wasaveattributes', JSON.stringify([{'style': {'name': saveAttributes[0]['style'], 'value': elements[i].style[saveAttributes[0]['style']]}}]));
              }
            }
          }
        }
        else
        {
          elements[i].setAttribute('data-waelementmarker', '1');
        }
      }
    }
  }


  function unmarkExistingElements (elementName, removeAttributes)
  {
    var i,
      savedAttributes,
      elements = pEditor.iFrameDoc.body.getElementsByTagName(elementName);

    if (elements && elements.length)
    {
      for (i = elements.length; i--;)
      {
        elements[i].removeAttribute('data-waelementmarker');

        if (removeAttributes)
        {
          elements[i].style[removeAttributes[0]['style']] = '';
        }

        if (elements[i].getAttribute('data-wasaveattributes'))
        {
          savedAttributes = JSON.parse(elements[i].getAttribute('data-wasaveattributes'));

          if (savedAttributes && savedAttributes.length)
          {
            if (savedAttributes[0]['style'] && savedAttributes[0]['style'].name && savedAttributes[0]['style'].value != null)
            {
              elements[i].style[savedAttributes[0]['style'].name] = savedAttributes[0]['style'].value;
            }
          }

          elements[i].removeAttribute('data-wasaveattributes');
        }
      }
    }
  }
}